<div class="community">
  <div class="community-container">
    <div class="section-header">
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
        />
      </svg>
      <h2>互动社区</h2>
    </div>

    <div class="channels-grid">
      <!-- 微信公众号卡片 -->
      <div class="channel-card">
        <div class="icon-wrapper icon-wechat">
          <span nz-icon nzType="wechat" nzTheme="outline"></span>
        </div>
        <h3>环球巴士</h3>
        <p>微信公众号</p>
        <button class="action-btn btn-wechat" (click)="openModal('assets/community/wechat.png')">微信搜索关注</button>
      </div>

      <!-- Telegram群组卡片 -->
      <div class="channel-card">
        <div class="icon-wrapper icon-tg">
          <svg
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="var(--tg-color)"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.446 1.394a.759.759 0 0 1-.6.28h-.01l.212-3.054 5.558-5.022c.243-.216-.052-.334-.373-.12L9.306 13.1l-2.66-.83c-.577-.18-.59-.577.12-.854l10.38-4c.48-.18.9.108.748.805z"
            />
          </svg>
        </div>
        <h3>官方交流群</h3>
        <p>Telegram 群组</p>
        <button class="action-btn btn-tg" (click)="openModal('assets/community/Telegram.png')">点击加入</button>
      </div>
    </div>
  </div>

  <!-- 弹窗遮罩 -->
  <div class="modal-overlay" *ngIf="showModal" (click)="closeModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <button class="modal-close" (click)="closeModal()">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="#999" stroke-width="2" stroke-linecap="round">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
      <img [src]="modalImage" alt="" />
    </div>
  </div>
</div>
